import { generate as shortid } from "shortid";
import { ProcessCanceled, UserCanceled } from "../../util/CustomErrors";
import Debouncer from "../../util/Debouncer";
import local from "../../util/local";
import { batchDispatch } from "../../util/util";
import { addHistoryEvent, markHistoryReverted, setHistoryEvent, showHistory, } from "./actions";
import HistoryDialog from "./HistoryDialog";
import { persistentReducer, sessionReducer } from "./reducers";
const stacks = local("history-stacks", {});
function registerHistoryStack(id, options) {
    stacks[id] = options;
}
function makeAddToHistory(api) {
    let actions = [];
    const debouncer = new Debouncer(() => {
        batchDispatch(api.store, actions);
        actions = [];
        return Promise.resolve();
    }, 1000, false, false);
    return (stack, entry) => {
        actions.push(addHistoryEvent(stack, {
            ...entry,
            reverted: false,
            id: shortid(),
            timestamp: Date.now(),
        }, stacks[stack].size));
        debouncer.schedule();
    };
}
function onErrorImpl(api, err, evt, stackId) {
    const allowReport = !(err instanceof ProcessCanceled || err instanceof UserCanceled);
    api.showErrorNotification("Failed to revert event", err, { allowReport });
    if (evt.reverted) {
        api.store.dispatch(setHistoryEvent(stackId, { ...evt, reverted: false }));
    }
    api.store.dispatch(showHistory(undefined));
}
function init(context) {
    context.registerReducer(["persistent", "history"], persistentReducer);
    context.registerReducer(["session", "history"], sessionReducer);
    context.registerHistoryStack = registerHistoryStack;
    context.registerAPI("addToHistory", makeAddToHistory(context.api), {});
    context.registerAPI("showHistory", (stackId) => {
        context.api.store.dispatch(showHistory(stackId));
    }, {});
    const onClose = () => context.api.store.dispatch(showHistory(undefined));
    const onReverted = (stackId, evt) => context.api.store.dispatch(markHistoryReverted(stackId, evt));
    const onError = (err, stackId, evt) => onErrorImpl(context.api, err, evt, stackId);
    context.registerDialog("history-dialog", HistoryDialog, () => {
        return {
            onClose,
            onReverted,
            onError,
            stacks,
        };
    });
    return true;
}
export default init;
